import { useDispatch } from "react-redux";
import { problems } from "./problems";
import { setProblems } from "../../../../entities/patient-stats/problems/problems.slice";

export const useGetProblems = () => {
  const dispatch = useDispatch();

  const getProblemsByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = problems.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0]);
      }, 400);
    }); // имитация API

    dispatch(setProblems(res)); // сохраняем в сторе
  };

  return {
    getProblemsByPatientId,
  };
};
